import React from "react";
import { useSelector } from "react-redux";
import { Dialog } from "@mui/material";
import { useAppDispatch } from "src/hooks/redux";
import { logoutSuccess } from "src/store/reducers/authSlice";

import { closeModal,ModalType } from "../../store/reducers/modalSlice";

import { AssignModal } from "./AssignModal";
import { AttentionModal } from "./AttentionModal";
import { DeleteModal } from "./DeleteModal";
import { LogOutModal } from "./LogOutModal";
import { MoveModal } from "./MoveModal";
import { SuccessModal } from "./SuccessModal";

const MODALS = {
  [ModalType.SUCCESS]: SuccessModal,
  [ModalType.DELETE]: DeleteModal,
  [ModalType.ATTENTION]: AttentionModal,
  [ModalType.LOG_OUT]: LogOutModal,
  [ModalType.MOVE]: MoveModal,
  [ModalType.ASSIGN]: AssignModal,
};

export const RootModal = () => {
  const dispatch = useAppDispatch();

  const { isModalOpen: isOpen, modalParams } = useSelector(
    (state: any) => state.modal
  );

  // @ts-ignore
  const ModalComponent = MODALS[modalParams.modalType];

  const handleModalClose = () => {
    if(modalParams.modalType === ModalType.LOG_OUT) {
      dispatch(logoutSuccess())
      dispatch(closeModal())
    }
    dispatch(closeModal());
  };

  return (
    <Dialog
      open={isOpen}
      onClose={handleModalClose}
      disableEscapeKeyDown
      PaperProps={{ sx: { borderRadius: "16px" } }}
    >
      {/*@ts-ignore*/}
      <ModalComponent {...modalParams} />
    </Dialog>
  );
};
